import { 
  collection, 
  addDoc, 
  query, 
  where, 
  getDocs, 
  deleteDoc,
  serverTimestamp
} from 'firebase/firestore';
import { firestore } from './firebase';
import { Notification } from '../types';

// Crear una notificación de solicitud de amistad
export const createFriendRequestNotification = async (
  userId: string,
  senderUserId: string
): Promise<void> => {
  try {
    console.log(`Creando notificación de solicitud de amistad para userId=${userId} de senderUserId=${senderUserId}`);
    
    // Comprobar si ya existe una notificación similar
    const existingQuery = query(
      collection(firestore, 'notifications'),
      where('userId', '==', userId),
      where('type', '==', 'friend_request'),
      where('read', '==', false),
      where('displayed', '==', false),
      where('relatedId', '==', senderUserId)
    );
    
    const existingDocs = await getDocs(existingQuery);
    
    // Si ya existe una notificación, no crear otra
    if (!existingDocs.empty) {
      console.log('Ya existe una notificación similar, no se creará una nueva');
      return;
    }
    
    const notificationData = {
      userId,
      type: 'friend_request',
      title: 'Nueva solicitud de amistad',
      message: 'Has recibido una nueva solicitud de amistad',
      relatedId: senderUserId,
      read: false,
      displayed: false,
      createdAt: serverTimestamp()
    };
    
    console.log('Guardando notificación:', notificationData);
    const docRef = await addDoc(collection(firestore, 'notifications'), notificationData);
    console.log('Notificación creada con ID:', docRef.id);
    
  } catch (error) {
    console.error('Error al crear notificación de solicitud de amistad:', error);
  }
};

// Crear una notificación de aceptación de amistad
export const createFriendAcceptedNotification = async (
  userId: string,
  accepterUserId: string
): Promise<void> => {
  try {
    console.log(`Creando notificación de aceptación de amistad para userId=${userId} de accepterUserId=${accepterUserId}`);
    
    // Comprobar si ya existe una notificación similar
    const existingQuery = query(
      collection(firestore, 'notifications'),
      where('userId', '==', userId),
      where('type', '==', 'friend_accepted'),
      where('relatedId', '==', accepterUserId)
    );
    
    const existingDocs = await getDocs(existingQuery);
    
    // Si ya existe una notificación, no crear otra
    if (!existingDocs.empty) {
      console.log('Ya existe una notificación similar, no se creará una nueva');
      return;
    }
    
    const notificationData = {
      userId,
      type: 'friend_accepted',
      title: 'Solicitud aceptada',
      message: 'Tu solicitud de amistad ha sido aceptada',
      relatedId: accepterUserId,
      read: false,
      displayed: false,
      createdAt: serverTimestamp()
    };
    
    console.log('Guardando notificación:', notificationData);
    const docRef = await addDoc(collection(firestore, 'notifications'), notificationData);
    console.log('Notificación creada con ID:', docRef.id);
    
  } catch (error) {
    console.error('Error al crear notificación de amistad aceptada:', error);
  }
};

// Crear una notificación de rutina compartida
export const createRoutineSharedNotification = async (
  userId: string,
  routineId: string
): Promise<void> => {
  try {
    console.log(`Creando notificación de rutina compartida para userId=${userId} con routineId=${routineId}`);
    
    // Comprobar si ya existe una notificación similar
    const existingQuery = query(
      collection(firestore, 'notifications'),
      where('userId', '==', userId),
      where('type', '==', 'routine_shared'),
      where('relatedId', '==', routineId)
    );
    
    const existingDocs = await getDocs(existingQuery);
    
    // Si ya existe una notificación, no crear otra
    if (!existingDocs.empty) {
      console.log('Ya existe una notificación similar, no se creará una nueva');
      return;
    }
    
    const notificationData = {
      userId,
      type: 'routine_shared',
      title: 'Nueva rutina compartida',
      message: 'Alguien ha compartido una rutina contigo',
      relatedId: routineId,
      read: false,
      displayed: false,
      createdAt: serverTimestamp()
    };
    
    console.log('Guardando notificación:', notificationData);
    const docRef = await addDoc(collection(firestore, 'notifications'), notificationData);
    console.log('Notificación creada con ID:', docRef.id);
    
  } catch (error) {
    console.error('Error al crear notificación de rutina compartida:', error);
  }
};

// Eliminar notificaciones antiguas (útil para limpiar)
export const deleteOldNotifications = async (
  userId: string,
  olderThanDays: number = 30
): Promise<void> => {
  try {
    const cutoffDate = new Date();
    cutoffDate.setDate(cutoffDate.getDate() - olderThanDays);
    
    const oldNotificationsQuery = query(
      collection(firestore, 'notifications'),
      where('userId', '==', userId),
      where('createdAt', '<', cutoffDate)
    );
    
    const oldNotificationsDocs = await getDocs(oldNotificationsQuery);
    
    const deletePromises = oldNotificationsDocs.docs.map(doc => 
      deleteDoc(doc.ref)
    );
    
    await Promise.all(deletePromises);
    
  } catch (error) {
    console.error('Error al eliminar notificaciones antiguas:', error);
  }
}; 